import { render } from "./PriceCalculator.vue?vue&type=template&id=533e8c9a"
import script from "./PriceCalculator.vue?vue&type=script&lang=js"
export * from "./PriceCalculator.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Products/PriceCalculator.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "533e8c9a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('533e8c9a', __exports__)) {
    api.reload('533e8c9a', __exports__)
  }
  
  module.hot.accept("./PriceCalculator.vue?vue&type=template&id=533e8c9a", () => {
    api.rerender('533e8c9a', render)
  })

}


export default __exports__